import Vue from 'vue'
import Router from 'vue-router'

import home from '@/views/home/index.vue'

// 市场领域
import marketArea from '@/views/marketArea/index.vue'
import chemicalEngineering from '@/views/marketArea/chemicalEngineering.vue'
import spaceflight from '@/views/marketArea/spaceflight.vue'
import electron from '@/views/marketArea/electron.vue'
import AI from '@/views/marketArea/AI.vue'
import transportation from '@/views/marketArea/transportation.vue'
import newEnergy from '@/views/marketArea/newEnergy.vue'
import architecture from '@/views/marketArea/architecture.vue'
import homeAppliances from '@/views/marketArea/homeAppliances.vue'

// 产品中心
import productCenter from '@/views/productCenter/index.vue'
import productInfo from '@/views/productCenter/productInfo.vue'


import serviceSupport from '@/views/serviceSupport/index.vue'
import serviceSupportProductInfo from '@/views/serviceSupport/productInfo.vue'
import serviceSupportDevelopment from '@/views/serviceSupport/development.vue'
import serviceSupportApplication from '@/views/serviceSupport/application.vue'
import serviceSupportSimulation from '@/views/serviceSupport/simulation.vue'

import news from '@/views/news/index.vue'

import contactUs from '@/views/contactUs/index.vue'
import recruit from '@/views/contactUs/recruit.vue'






Vue.use(Router)

const router = new Router({
  // 配置滚动行为，确保路由切换时页面滚动到顶部
  scrollBehavior(to, from, savedPosition) {
    // 如果有保存的位置（例如浏览器前进/后退），则返回保存的位置
    if (savedPosition) {
      return savedPosition
    }
    // 否则滚动到顶部
    return { x: 0, y: 0 }
  },
  routes: [
    {
      path: '/',
      redirect: '/index'
    },
    {
      path: '/index', // 首页
      component: home
    },
    {
      path: '/marketArea', // 市场领域
      component: marketArea,
      children: [
        {
          path: 'chemicalEngineering', // 市场领域-化工
          component: chemicalEngineering,
        },
        {
          path: 'spaceflight', // 市场领域-航天
          component: spaceflight,
        },
        {
          path: 'electron', // 市场领域-电子
          component: electron,
        },
        {
          path: 'AI', // 市场领域-AI
          component: AI,
        },
        {
          path: 'transportation', // 市场领域-交通
          component: transportation,
        },
        {
          path: 'newEnergy', // 市场领域-新能源
          component: newEnergy,
        },
        {
          path: 'architecture', // 市场领域-建筑
          component: architecture,
        },
        {
          path: 'homeAppliances', // 市场领域-家电
          component: homeAppliances,
        }
      ]
    },
    {
      path: '/productCenter', // 产品中心
      component: productCenter,
      children: [
        {
          path: 'productInfo',
          component: productInfo
        }
      ],
    },
    {
      path: '/serviceSupport', // 服务与支持
      component: serviceSupport,
      children: [
        {
          path: 'productInfo',
          component: serviceSupportProductInfo
        },
        {
          path: 'development',
          component: serviceSupportDevelopment
        },
        {
          path: 'application',
          component: serviceSupportApplication
        },
        {
          path: 'simulation',
          component: serviceSupportSimulation
        },
      ],
    },
    {
      path: '/news', // 新闻中心
      component: news
    },
    {
      path: '/contactUs', // 联系我们
      component: contactUs,
      children: [
        {
          path: 'recruit',
          component: recruit
        }
      ],
    },
  ]
})

// 添加全局后置守卫，确保每次路由切换后都滚动到顶部
router.afterEach(() => {
  // 延迟一点执行，确保DOM已经更新
  setTimeout(() => {
    window.scrollTo(0, 0)
    document.documentElement.scrollTop = 0
    document.body.scrollTop = 0
  }, 100)
})

export default router